import React from 'react';
import NavigateNext from '@mui/icons-material/NavigateNext';
import styles from './ReportResultBlockMobile.module.scss';
import { Button } from 'tt-ui-lib/core';
import CalcMenuButton from '../../../CalcMenuButton/CalcMenuButton';

const ReportResultBlockMobile = ({ props }) => {
  const { assessment, targetWidth, calcLogo, onViewClick, onMenuClick } = props;

  return (
    <>
      <div key={assessment.id} className={styles.rowWrapper}>
        <div className={styles.first}>
          <div className={styles.draftName}>
            {calcLogo && <div className={styles.logo}>{calcLogo}</div>}
            <div
              className={styles.title}
              title={assessment.name}
              style={{ maxWidth: targetWidth - 250 }}
            >
              {assessment.name || '-'}
            </div>
          </div>
        </div>
        <div className={styles.info}>
          <div className={styles.container}>
            <p className={styles.data}>Reporting period:</p>
            <p className={styles.dataValue}>
              {assessment.periodReportDate.getFullYear() ?? 'wrong date'}
            </p>
          </div>
        </div>
        <div className={styles.buttonCont}>
          <Button className={styles.payBtn} onClick={() => onViewClick(assessment.id)}>
            View more
          </Button>
          <CalcMenuButton params={{ onMenuClick }} />
        </div>
      </div>
    </>
  );
};

export default ReportResultBlockMobile;
